import { render, staticRenderFns } from "./PetAndProjectCommentForm.vue?vue&type=template&id=961f2552&scoped=true&"
import script from "./PetAndProjectCommentForm.vue?vue&type=script&lang=js&"
export * from "./PetAndProjectCommentForm.vue?vue&type=script&lang=js&"
import style0 from "./PetAndProjectCommentForm.vue?vue&type=style&index=0&id=961f2552&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961f2552",
  null
  
)

export default component.exports